import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { labelText, labelTextWithSupportingText } from './styles';
export const LabelText = ({ hasSupportingText, children, }) => {
    return (_jsx("div", Object.assign({ css: (theme) => [
            labelText(theme.checkbox && theme),
            hasSupportingText ? labelTextWithSupportingText : '',
        ] }, { children: children }), void 0));
};
//# sourceMappingURL=LabelText.js.map
